import type { EntityIdPayload, SignalingEventPayload } from 'services/signaling';
import type { UserHandLoweredPayload, UserHandRaisedPayload } from 'features/users/types';
import type {
  PhoneStreamStarted,
  PhoneUsersJoinedPayload,
  PhoneUsersLeftPayload,
} from 'features/sip/types';

import { createAction } from '@reduxjs/toolkit';
import { type DeviceAskedToUnmuteRemotely } from 'features/streaming/types';

export const connectToPhoneBridgeRequested = createAction('sip/connectToPhoneBridgeRequested');

export const signalingPhoneBridgeConnecting = createAction('signaling/sip/phoneBridgeConnecting');

export const signalingPhoneBridgeConnected = createAction('signaling/sip/phoneBridgeConnected');

export const disconnectFromPhoneBridgeRequested = createAction(
  'sip/disconnectFromPhoneBridgeRequested'
);
export const signalingPhoneBridgeDisconnected = createAction(
  'signaling/sip/phoneBridgeDisconnected'
);

export const signalingPhoneStreamStarted = createAction<PhoneStreamStarted>(
  'signaling/sip/phoneStreamStarted'
);

export const phoneStreamDeleted = createAction<string>('sip/phoneStreamDeleted');

export const muteRemotePhoneUserRequested = createAction<EntityIdPayload>(
  'sip/mutePhoneUserRequested'
);
export const unmuteRemotePhoneUserRequested = createAction<EntityIdPayload>(
  'sip/unmutePhoneUserRequested'
);

export const signalingPhoneUserMuted = createAction<EntityIdPayload>(
  'signaling/sip/phoneUserMuted'
);
export const signalingPhoneUserUnmuted = createAction<EntityIdPayload>(
  'signaling/sip/phoneUserUnmuted'
);

export const signalingPhoneUsersJoined = createAction<PhoneUsersJoinedPayload>(
  'signaling/sip/phoneUsersJoined'
);
export const signalingPhoneUsersLeft = createAction<PhoneUsersLeftPayload>(
  'signaling/sip/phoneUsersLeft'
);

export const signalingPhoneUserHandRaised = createAction<UserHandRaisedPayload>(
  'signaling/sip/handRaised'
);
export const signalingPhoneUserHandLowered = createAction<UserHandLoweredPayload>(
  'signaling/sip/handLowered'
);

export const signalingPhoneUserAskedToUnmute = createAction<
  SignalingEventPayload<DeviceAskedToUnmuteRemotely>
>('signaling/sip/userAskedToUnmute');

export const phoneUserLowerHand = createAction<string>('sip/lowerHand');
